module.exports = __webpack_public_path__ + "static/Pay2Day-Logo-White-d73d105ddca042d4339bd18284a8507b.png";